const FORWARDING_TYPE = {
  FORWARD: { label: '출고지', color: 'green', value: 'FORWARD' },
  RECEIVE: { label: '수령지', color: 'orange', value: 'RECEIVE' },
};

export { FORWARDING_TYPE };
